// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/4039
import type { PAPEventGeneric } from "../base/event";
import type { PreviewModalInteractionType } from "../enums/preview_modal_interaction_type";

// Event_name: 'interact.result_preview_modal'
// Description: Interact with the result preview modal
// Owner: dash-exp-find-and-discover
export type Interact_ResultPreviewModal = PAPEventGeneric<
  'previews',
  'interact',
  'result_preview_modal',
  {
    // Unique identifier for a viewing session of a preview
    previewModalUuid?: string;
    // Interaction type within the preview modal
    previewModalInteractionType?: PreviewModalInteractionType;
    // Value that represents the level of scale/zoom
    zoomPercent?: number;
    // Width of side panel using percentage-based widths
    sidePanelWidthPercent?: number;
  }
>;

export function PAP_Interact_ResultPreviewModal(properties?: Interact_ResultPreviewModal['properties']): Interact_ResultPreviewModal {
  return <Interact_ResultPreviewModal>{
    class: 'previews',
    action: 'interact',
    object: 'result_preview_modal',
    properties,
  };
}
